module.exports = __webpack_public_path__ + "components/breakheader/static/surf-alert-f3a352b56f10acc57849aa752ddf3c1e.png";